<template lang="pug">
div
  h3.page-title {{$route.meta.title}}
  el-card
    template(slot="header")
      div(v-if="$route.meta.topConfig")
        el-row
          common-search-filter(ref="searchFilter" :filters="searchFilters")
        el-row
          component(v-for="(op, index) of topOperators" :key="index" :is="op.component ? op.component : 'el-button'" v-power:[op.power] v-bind="op.attrs" v-on="op.events") {{op.name}}
    common-table(
      :isloading="isLoading"
      :headermap="headermap"
      :data="data"
      :basicdata="basicdata"
      )
  el-dialog(
    v-if="isOpen && $route.meta.pageDialogConfig"
    :visible.sync="isOpen"
    :title="dlTitle"
    )
    common-form(
      ref="form"
      :type-extends="extendsConfig"
      :options="formInfo"
      :values="value"
      )
    span(slot="footer" class="dialog-footer")
      el-button(@click="isOpen = false") 取 消
      el-button(type="primary" @click="Submit") 确 定
</template>

<script>


export default {
  name: 'CommonListPage',
  data() {
    return {
      searchFilters: [],
      isLoading: false,
      topOperators: null,
      headermap:[],
      data: [],
      formInfo: [],
      editConfig: null,
      addConfig: null,
      submit: null,
      getListFunc: null,
      basicdata: {

      }
    }
  },
  computed: {
    isOpen: {
      set(state) {
        if (!state) {
          this.$store.commit('closeDialog')
        }
      },
      get() {
        return this.isAddOpen || this.isEditOpen
      }
    },
    isAddOpen() {
      return this.$store.state.isAddOpen
    },
    isEditOpen() {
      return this.$store.state.isEditOpen
    },
    dlTitle() {
      return this.$store.state.dialogTitle
    },
    value() {
      return this.$store.state.pageValue
    },
    listSig() {
      return this.$store.state.listSig
    },
    viewType() {
      return this.$store.state.viewType
    },
    extendsConfig() {
      let configName = this.viewType + 'Config'
      let config = this[configName]
      return config
    }
  },
  watch: {
    listSig() {
      console.log('list sig')
      this.getListData()
    },
    $route() {
      console.log('route trigger init')
      this.init()
    }
  },
  methods: {
    async getListData() {
      this.isLoading = true
      if (this.getListFunc) {
        let query = {...this.$route.query}
        let res = await this.getListFunc(query)
        if (res) {
          this.data = res.items
          let { count } = res
          this.basicdata = {
            pageSize: this.$route.query.limit || 15,
            currentPage: this.$route.query.page || 1,
            total: count
          }
          this.EventBus.$emit('listData', {
            data: this.data,
            count
          })
        }  
      }
      this.isLoading = false
    },
    async Submit() {
      let {hasError, form} = this.$refs.form.getFormData()
      if (this.submit) {
        await this.submit({hasError, form})
      }
    },
    bindTableOperator(events) {
      if(!events) return
      this.headermap.find((head) => {
        return head.key === 'op'
      }).comEvents = events
    },
    bindTopOperators(events) {
      if(!events) return
      for (let e in events) {
        this.topOperators.find((op) => {
          return op.key === e
        }).events = events[e]
      }
    },
    bindDialogSubmit(Submit) {
      this.submit = Submit
    },
    bindGetListData(getListData) {
      this.getListFunc = getListData
    },
    init() {
      this.topOperators = []
      this.headermap = []
      this.data = []
      this.formInfo = []
      this.editConfig = null
      this.addConfig = null
      this.submit = null
      this.getListFunc = null

      const { headermap, tableEvents, getListData } = (this.$route.meta.viewConfig || {})
      const { formInfo, Submit, addConfig, editConfig } = (this.$route.meta.pageDialogConfig || {})
      const { topOperators, topOperatorEvents, searchFilters } = (this.$route.meta.topConfig || {})
      this.searchFilters = searchFilters || []
      this.topOperators = topOperators || []
      this.headermap = headermap || []
      this.formInfo = formInfo || []
      this.editConfig = editConfig || {}
      this.addConfig = addConfig || {}
      this.bindTableOperator(tableEvents)
      this.bindTopOperators(topOperatorEvents)
      this.bindDialogSubmit(Submit)
      this.bindGetListData(getListData)
      this.getListData()
    }
  },
  mounted  () {
    this.init()
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/style/index.less';

</style>
